module.exports = __webpack_public_path__ + "img/23_SDA.6a2f58d6.png";